// extracted by mini-css-extract-plugin
export default {"doctorsPage":"Appointment_doctorsPage__6ctnU","pageTitle":"Appointment_pageTitle__EmVgf","titleText":"Appointment_titleText__0P9Cv","titleLogo":"Appointment_titleLogo__YTfJO"};